import { displayDate } from 'shared/libs/dayjs/helpers'
import { apiDateFormat } from 'shared/libs/dayjs/model'
import { requiredText } from 'shared/libs/text/requered-text'
import {
  inputClassname,
  placeholderClassname,
  wrapperClassName,
} from 'shared/model/classnames'

import { RenderFormItem } from 'shared/ui/Form/FormItems'

const rules = [{ required: true, message: requiredText }]
export const addUserInfoFormFields: RenderFormItem[] = [
  {
    type: 'customTextField',
    itemProps: {
      placeholder: 'ФИО',
      className: inputClassname,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
    },
    formItemProps: {
      name: 'full_name',
      rules: rules,
    },
  },
  {
    type: 'inputPhoneNumber',
    itemProps: {
      placeholder: 'Номер телефона',
      className: inputClassname,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
      inputType: 'custom',
    },
    formItemProps: {
      name: 'phone_number',
      rules: rules,
    },
  },
  {
    type: 'customDatePickerField',
    itemProps: {
      placeholder: 'Дата рождения',
      className: `w-full rounded-[12px] border-light_gray_10`,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
    },
    formItemProps: {
      name: 'date_of_birth',
      normalize: (value) => (value ? displayDate(value, apiDateFormat) : value),
    },
  },
  {
    type: 'customTextField',
    itemProps: {
      placeholder: 'Контактное лицо',
      className: inputClassname,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
    },
    formItemProps: {
      name: 'contact_name',
    },
  },
  {
    type: 'customTextField',
    itemProps: {
      placeholder: 'Кем приходится пользователю',
      className: inputClassname,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
    },
    formItemProps: {
      name: 'contact',
    },
  },
  {
    type: 'inputPhoneNumber',
    itemProps: {
      placeholder: 'Номер телефона контактного лица',
      className: inputClassname,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
      inputType: 'custom',
      value: '996',
    },
    formItemProps: {
      name: 'contact_phone_number',
    },
  },
  {
    type: 'customTextField',
    itemProps: {
      type: 'email',
      placeholder: 'Электронная почта',
      className: inputClassname,
      wrapperClassname: wrapperClassName,
      placeholderClassname: placeholderClassname,
    },
    formItemProps: {
      name: 'email',
      rules: [
        {
          type: 'email',
          message: 'Введите верный адрес электронной почты',
        },
      ],
      validateTrigger: 'submit',
    },
  },
]
